import { isValidElement } from 'react';

import cx from 'classnames';

import { confirmationTableDataSelector } from 'selectors/placeOrderSelector';
import { useAppSelector } from 'storeHooks';

import styles from './Modals.module.scss';

const ConfirmationTable = () => {
  const { confirmationTable: data } = useAppSelector(confirmationTableDataSelector);
  return (
    (<span data-palette="ConfirmationTable">
      {data?.map?.((item, index) => (
        <div
          key={item.id}
          className={cx('d-flex', styles.rowMargin, {
            [styles.odd]: (index + 1) % 2 !== 0,
            [styles.even]: (index + 1) % 2 === 0,
          })}
          data-testid="confirmation-table"
          data-palette="ConfirmationTable">
          <div
            className={cx('col-xxs-13', styles.label)}
            data-testid="confirmation-table-label"
          >
            {item.label}
          </div>
          <div
            className={cx('col-xxs-11', styles.value, {
              [styles.striked]: item.strikedValue,
            })}
            data-testid="confirmation-table-value"
          >
            {item.strikedValue && (
              <s
                data-testid="confirmation-table-striked-value"
                data-palette="ConfirmationTable">{item.strikedValue}</s>
            )}
            {isValidElement(item?.value)
              ? item.value
              : item.value && item.value.replace('NaN', '-')}
            {item.bottomText && (
              <div
                className={cx('col-xxs-24', styles.bottomText)}
                data-testid="confirmation-table-bottom-text"
                data-palette="ConfirmationTable">
                {item.bottomText}
              </div>
            )}
          </div>
        </div>
      ))}
    </span>)
  );
};

export default ConfirmationTable;
